(function() {

   document.querySelectorAll(".header__inline-menu details").forEach(item => {
        item.addEventListener("mouseenter", () => {
            item.setAttribute("open", true);
        });
        item.addEventListener("mouseleave", () => {
            item.removeAttribute("open");
        });
    });

    const backToTop = document.getElementById("backToTop");
    window.addEventListener("scroll", () => {
        const scrollTop = window.scrollY;
        const docHeight =
        document.documentElement.scrollHeight - window.innerHeight;
        const scrolledPercent = (scrollTop / docHeight) * 100;

        backToTop.style.display = scrolledPercent >= 15 ? "block" : "none";
    });
    backToTop.addEventListener("click", () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    });
    
})();
